/**
 * to set the cookie
 * @param name name of cookie
 * @param value value of cookie
 * @param timeInMin expiration of cookie in min
 * @param toExpire flag to expire a cookie. Default: false
 */
const setCookie = (name: string, value: string, timeInMin?: number, toExpire = false): void => {
    let expires = '';
    if (typeof timeInMin === 'number') {
        const date = new Date();
        date.setTime(date.getTime() + timeInMin * 60 * 1000);
        expires = ';expires=' + date.toUTCString();
    } else if (toExpire) {
        expires = ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

/**
 * to get the cookie against the provided cookie name
 * @param name name of cookie
 * @returns string | null
 */
function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2];
    }
    return null;
}
/**
 * delete cookie.
 * @param name name of the cookie
 */
const deleteCookie = (name: string) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};

export { setCookie, getCookie, deleteCookie };
